<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div class="row mt-2">
      <div class="col-12">
        <h4>Tournoi en salle</h4>
        <p>Animez une partie de duplicate dans votre club : l'écran de la salle affiche le tirage, le chrono et le
          classement ; les joueurs saisissent leur mot sur leur mobile, ou sur un bulletin papier que vous saisissez.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-5 mb-4">
        <div class="card">
          <div class="card-header">Nouvelle partie</div>
          <div class="card-body">
            <form v-on:submit.prevent="create">
              <div class="mb-3">
                <label for="room-game-name">Nom de la partie</label>
                <input id="room-game-name" class="form-control" v-model="name" maxlength="60" placeholder="Club du jeudi" />
              </div>
              <div class="mb-3">
                <label for="room-round-time">Temps de jeu par coup</label>
                <select id="room-round-time" class="form-select" v-model.number="roundTime">
                  <option v-for="time in times" v-bind:key="time" v-bind:value="time">{{ timeLabel(time) }}</option>
                </select>
              </div>
              <div class="mb-3">
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="room-draw-auto" value="auto" v-model="drawMode" />
                  <label class="form-check-label" for="room-draw-auto">Tirage par l'ordinateur</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="room-draw-manual" value="manual" v-model="drawMode" />
                  <label class="form-check-label" for="room-draw-manual">Tirage à la main (vous tapez les lettres sorties du sac)</label>
                </div>
              </div>
              <div v-if="error" class="text-danger mb-2">{{ error }}</div>
              <button type="submit" class="btn btn-primary" v-bind:disabled="creating">Créer la partie</button>
            </form>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-7 mb-4">
        <h5>Mes parties</h5>
        <div v-if="games === undefined">Chargement…</div>
        <div v-else-if="games.length === 0" class="text-muted">Aucune partie pour l'instant.</div>
        <table v-else class="table table-sm">
          <thead>
            <tr><th>Partie</th><th>Date</th><th>État</th><th>Vainqueur</th></tr>
          </thead>
          <tbody>
            <tr v-for="game in games" v-bind:key="game.id">
              <td><router-link v-bind:to="`/salle/${game.id}`">{{ game.name }}</router-link></td>
              <td>{{ dateLabel(game.createdAt) }}</td>
              <td>{{ phases[game.phase] }}<span v-if="game.phase !== 'waiting' && game.phase !== 'over'">,
                coup {{ game.roundNumber }}</span></td>
              <td>{{ game.winners.join(', ') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import iam from '../../iam';
import api, { errorMessage } from '../../salle/api';
import { PHASES, timeLabel } from '../../salle/labels';
import LoggedUser from '../LoggedUser.vue';
import BottomNav from '../BottomNav.vue';

// Parties en salle de l'arbitre (historique) et création d'une partie
export default {
  name: 'RoomHome',
  components: { LoggedUser, BottomNav },
  data() {
    return {
      name: '',
      roundTime: 180,
      drawMode: 'auto',
      times: [180, 150, 120, 90, 60],
      games: undefined,
      error: undefined,
      creating: false,
      phases: PHASES,
    };
  },
  created() {
    api.listGames()
      .then((games) => {
        this.games = games;
      })
      .catch((error) => {
        this.games = [];
        this.error = errorMessage(error);
      });
  },
  methods: {
    timeLabel,
    dateLabel(timestamp) {
      return new Date(timestamp).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' });
    },
    create() {
      this.creating = true;
      this.error = undefined;
      const user = iam.getConnectedUser();
      api.createGame({ name: this.name, roundTime: this.roundTime, drawMode: this.drawMode, refereeName: user && user.username })
        .then(state => this.$router.push(`/salle/${state.game.id}`))
        .catch((error) => {
          this.error = errorMessage(error);
          this.creating = false;
        });
    },
  },
};
</script>
